import React from "react";
import { Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import Card from "../Card";
import { Container } from "reactstrap";

export const NoAccess = () => {
  const { t } = useTranslation();

  return (
    <Container fluid>
      <Row justify="center" style={{ marginTop: "60px" }}>
        <Col xs={24} sm={20} md={16} lg={12} xl={10}>
          <Card className="text-center" style={{ padding: "60px 40px" }}>
            <div style={{ fontSize: "80px", marginBottom: "30px" }}>🔒</div>

            <h2
              style={{
                fontSize: "28px",
                fontWeight: "600",
                marginBottom: "20px",
                color: "#333",
              }}
            >
              {t("FORBIDDEN")}
            </h2>

            <p className="H5">{t("FORBIDDEN_DESCRIPTION")}</p>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
